import { isPersistentMenuJson, isDynamicEmbedJson, } from '../../generated/ast.js';
import { FRONTEND_PROPERTY_NAME, SYSTEM_NODES, } from '../../common/constants.js';
export function validatePersistentMenuNode(nodeFields, accept) {
    const { nodeTypeField, idField, richAssetField, nextNodesField, nluDisabledField, } = nodeFields;
    // The node number should be correct
    if (nodeFields.refNode.name !== SYSTEM_NODES.PERSISTENT_MENU_NODE) {
        accept('error', `Persistent menu embed is only allowed at node ${SYSTEM_NODES.PERSISTENT_MENU_NODE}.`, {
            node: nodeFields.refNode,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.refNode.name,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_TYPE,
            },
        });
    }
    // The node should be a decision node
    if (nodeTypeField?.nodeType?.value !== 'D') {
        accept('error', `Persistent menu node must be a decision node.`, {
            node: nodeFields.refNode,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.refNode.name,
                propertyName: FRONTEND_PROPERTY_NAME.NODE_TYPE,
            },
        });
    }
    // The node should have nluDisabled present and be set
    // to true (missing nluDisabled is considered as false)
    if (!nluDisabledField || nluDisabledField.nluDisabled === 'false') {
        accept('error', `Persistent menu node should have NLU set to diabled.`, {
            node: nodeFields.refNode,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.refNode.name,
                propertyName: FRONTEND_PROPERTY_NAME.NLU_DISABLED,
            },
        });
    }
    // If it's a static persistent menu, there should be
    // no next nodes defined
    if (richAssetField &&
        isPersistentMenuJson(richAssetField.content.value) &&
        nextNodesField?.nextNodes &&
        nextNodesField?.nextNodes?.length > 0) {
        accept('error', `A static persistent menu node may not have next nodes specified.`, {
            node: nodeFields.refNode,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.refNode.name,
                propertyName: FRONTEND_PROPERTY_NAME.NEXT_NODES,
            },
        });
    }
    // If it's a dynamic persistent menu, there should be
    // exactly one next node defined
    if (richAssetField &&
        isDynamicEmbedJson(richAssetField.content.value) &&
        nextNodesField?.nextNodes &&
        nextNodesField?.nextNodes?.length !== 1) {
        accept('error', `A dynamic persistent menu node must have a single next node specified.`, {
            node: nodeFields.refNode,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.refNode.name,
                propertyName: FRONTEND_PROPERTY_NAME.NEXT_NODES,
            },
        });
    }
}
//# sourceMappingURL=persistent-menu.js.map